import React, { useState } from 'react'
import axios from 'axios';
import { saveAs } from 'file-saver';
import { ColumnHeader } from './functions';
import { Encodingkeys } from './functions';
import { replaceEncodingIssue } from "./functions";
import * as XLSX from 'xlsx';
import Kentrix_Enrichment_Data_Dictionary from "../assets/Kentrix_Enrichment_Data_Dictionary_2023.xlsx"

const SingleURLPage = ({ setShowAlert, setAlertMessage, isSingle,setLoading,flap,user,refreshQuota }) => {

    const [address, setAddress] = useState("")
    const [finalData, setFinalData] = useState([])

    const handleAddressChange = (e) => {
        setAddress(e.target.value)
    };


    const handleSubmit = async () => {
        if (address) {
            setLoading(true);
            try {
                const response = await axios.get(user.api_url, {
                    params: {
                        address: address.toLowerCase(),
                        unique_id: Date.now(),
                        username:user.username
                    },
                    headers: {
                        'X-Api-Key': user.api_key,
                        'Content-Type': 'application/json',
                    },
                });
                setFinalData(response.data.response);
                setAlertMessage("Data successfully fetched.");
                setShowAlert(true);
                refreshQuota();
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 429) {
                        setAlertMessage("API Limit Exceeded: " + error.message);
                    } else if (error.response.status === 403) {
                        setAlertMessage("Forbidden. Wrong API key: " + error.message);
                    } else if (error.response.status === 504 || error.response.status === 500 || error.response.status === 401 || error.response.status === 502) {
                        setAlertMessage("Please Contact Kentrix: " + error.message);
                    } else {
                        setAlertMessage("An unexpected error occurred." + error);
                    }
                } else if (error.message === "Network Error") {
                    setAlertMessage("Forbidden. Wrong API URL: " + error.message);
                } else {
                    setAlertMessage("An unexpected error occurred.");
                }
                setShowAlert(true);
            } finally {
                setLoading(false);
            }
        } else {
            setAlertMessage('Please Enter the address');
            setShowAlert(true);
        }
    };


    for (const [key, value] of Object.entries(finalData)) {
        if (value === null) {
            finalData[key] = "None";
        }
    }

    // const exportToCSV = () => {
    //     const columnHeaderRow = `"Address",${ColumnHeader.map(header => `"${escapeDoubleQuotes(replaceEncodingIssue(header))}"`).join(',')}`;
    //     const valuesRow = `"${escapeDoubleQuotes(replaceEncodingIssue(address))}",${Encodingkeys.map((key) => {
    //         const value = finalData[key] || '';
    //         return `"${escapeDoubleQuotes(replaceEncodingIssue(value))}"`;
    //     }).join(',')}`;

    //     const finalCSVContent = `${columnHeaderRow}\n${valuesRow}`;

    //     const blob = new Blob([finalCSVContent], { type: 'text/csv;charset=utf-8' });
    //     saveAs(blob, 'data.csv');
    // };




    const exportData = async () => {
        try {
            const columnHeaderRow = ['Address', ...ColumnHeader.map(header => replaceEncodingIssue(header))];
            const valuesRow = [replaceEncodingIssue(address), ...Encodingkeys.map(key => {
                const value = finalData[key] || '';
                return replaceEncodingIssue(value);
            })];

            const data = [columnHeaderRow, valuesRow];
            const worksheet = XLSX.utils.aoa_to_sheet(data);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(workbook, worksheet, "Output"); // Add the first worksheet to the workbook

            // Read the Kentrix_Urban Excel file
            const response = await fetch(Kentrix_Enrichment_Data_Dictionary);
            const buffer = await response.arrayBuffer();
            const KentrixEnrichmentWorkbook = XLSX.read(buffer, { type: "array" });

            // Assuming Kentrix_Urban.xlsx contains only one sheet, you can directly access it
            const kentrixUrbanWorksheet = KentrixEnrichmentWorkbook.Sheets[KentrixEnrichmentWorkbook.SheetNames[0]];
            const kentrixRuralWorksheet = KentrixEnrichmentWorkbook.Sheets[KentrixEnrichmentWorkbook.SheetNames[1]];

            // Add the Kentrix_Urban worksheet to the existing workbook
            XLSX.utils.book_append_sheet(workbook, kentrixUrbanWorksheet, "Enrichment Dictionary -Urban");
            XLSX.utils.book_append_sheet(workbook, kentrixRuralWorksheet, "Enrichment Dictionary -Rural");

            // Convert the workbook to Excel buffer
            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            saveAs(blob, "Output.xlsx");
        } catch (error) {
            setAlertMessage("Error exporting data:", error);
            setShowAlert(true);
        }
    };


    return (
        <div>
            <div className="item_section">

                <div className="input_para_container">
                    <div className="input_para">
                        <input
                            type="text"
                            className="form-control shadow-none for_disable"
                            placeholder="Enter Address"
                            value={address}
                            onChange={handleAddressChange}
                            disabled={!isSingle}

                        />
                        <button onClick={handleSubmit} disabled={!isSingle}>Submit</button>
                    </div>
                    <p>Require Format: 'Building Name + Street Name / Sub Locality Name / Locality Name + Landmark if available + City +  PIN Code +State (Optional)'</p>
                </div>

                <div className="item_table_container">

                    <table className="item_table">
                        <thead>
                            <tr>
                                <th>Column Header</th>
                                <th>Column Value</th>
                            </tr>
                        </thead>
                        {/* <tbody>
                            {ColumnHeader.map((header, index) => (
                                <tr key={index}>
                                    <td>{header}</td>
                                    <td>{finalData[Encodingkeys[index]]}</td>
                                </tr>
                            ))}
                        </tbody> */}
                        <tbody>
                            {ColumnHeader.slice(0, 12).map((header, index) => (
                                <tr key={index}>
                                    <td>{header}</td>
                                    <td>{finalData[Encodingkeys[index]]}</td>
                                </tr>
                            ))}
                            <tr>
                                <th colSpan="2">Consumer Product Purchase Affinity</th>
                            </tr>
                            {ColumnHeader.slice(12,55).map((header, index) => (
                                <tr key={index}>
                                    <td>{header}</td>
                                    <td>{finalData[Encodingkeys[index + 12]]}</td>
                                </tr>
                            ))}
                            <tr>
                                <th colSpan="2">Model-fitted Consumer Profile Scores</th>
                            </tr>
                            {ColumnHeader.slice(55).map((header, index) => (
                                <tr key={index}>
                                    <td>{header}</td>
                                    <td>{finalData[Encodingkeys[index + 55]]}</td>
                                </tr>
                            ))}
                        </tbody>


                    </table>

                </div>
                <div className="btn_download">
                    <button
                        onClick={exportData}
                        disabled={finalData.length === 0}
                        className={finalData.length === 0 ? "disabled" : ""}
                    >
                        Download Data 
                    </button>
                </div>

            </div>

        </div>
    )
}

export default SingleURLPage